// Dependencies
import styled from 'styled-components';

type ContainerStyleProps = {
  isOpened: boolean;
};

export const Container = styled.div<ContainerStyleProps>`
  display: ${({ isOpened }) => (isOpened ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
`;

export const OverlayContainer = styled.div`
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(35, 35, 38, 0.8);

`;
